import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { Caption } from "../../atoms/views/Caption";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { useTranslation } from 'react-i18next';
import { Lock } from "../../atoms/views/Lock";



// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<boolean>;
export const Aanpasbaar = (props: AllProps) => {
    const classes = useStyles(useTheme());
        const { t: tCommon } = useTranslation('common');
    
        
    const label = props.label || tCommon('editable') || "Aanpasbaar";

    return (<Caption {...props} caption={label}>
        <Lock value={props.value === false} trueText={tCommon('no')} falseText={tCommon('yes')} />
    </Caption>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));